'use client';

import { useEffect } from 'react';

/** Galat di root layout panel: dokumen diganti, jadi <html>/<body> dirender sendiri. */
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <html lang="id">
      <body
        style={{
          margin: 0,
          minHeight: '100dvh',
          display: 'grid',
          placeItems: 'center',
          background: '#e9ebf0',
          color: '#171718',
          fontFamily: 'system-ui, sans-serif',
          padding: '2rem',
        }}
      >
        <div style={{ maxWidth: '44ch', textAlign: 'center' }}>
          <h1 style={{ fontSize: '1.5rem', margin: 0 }}>Panel sedang bermasalah</h1>
          <p style={{ marginTop: '0.75rem', lineHeight: 1.6 }}>
            Terjadi galat yang membuat panel tidak bisa ditampilkan. Coba muat ulang.
          </p>
          <button
            type="button"
            onClick={reset}
            style={{
              marginTop: '1.25rem',
              border: 0,
              borderRadius: 6,
              background: '#d2f801',
              color: '#171718',
              fontWeight: 700,
              padding: '0.7rem 1.25rem',
              cursor: 'pointer',
            }}
          >
            Coba lagi
          </button>
          {error.digest ? (
            <p style={{ marginTop: '0.75rem', fontSize: 12, opacity: 0.6 }}>Kode: {error.digest}</p>
          ) : null}
        </div>
      </body>
    </html>
  );
}
